module.exports = __webpack_public_path__ + "img/sidebar-background-galileo.22b6cdf8.jpg";